import { styled } from "@mui/material/styles";

export const DateStatusContainer = styled("div")(() => ({
  textAlign: "left",
  width: "100%",
}));
